export const DEFAULT_PAGE_SIZE = parseInt(process.env.REACT_APP_RESULTS_PER_PAGE!)
export const DEFAULT_PAGE_TITLE = 'OrderMate'
// export const DEFAULT_META_DESCPTION = 'OrderMate'

export const ERROR_MESSAGE_ACCOUNT_ON_HOLD =
  'There is an issue with your account. Please contact our Accounts Team on 01282 429446'
